import { useCallback, useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import slideOne from '../assets/REGAInewcarousel.avif';
import slideTwo from '../assets/theytriedcarousel.avif';
import slideThree from '../assets/hero-shift.webp';
import { MoveRight } from 'lucide-react';
import './HeroCarousel.css';
import { button } from 'framer-motion/client';
import strategyPdf from "../assets/pdfs/in'Symphonia Brand Strategy.pdf";
import shiftNhiPdf from '../assets/pdfs/Symphonia and the Shift with NHI (1).pdf';
import symphoniaPdf from '../assets/pdfs/Extended 03 Symphonia and the Shift with NHI (1).pdf';

const slides = [
    {
        id: 1,
        image: slideOne,
        subtitle: 'When Months Become Minutes From Regulatory Text to Executable Intelligence',
        title: 'VBS-REG-AI',
        description:
            'Reg-AI is Valoores’ AI-native regulatory intelligence engine that ingests Central Bank circulars and supervisory regulations and automatically converts complex legal text into actionable business logic and operational workflows',
        buttonText: 'Learn More',
        buttonLink: 'https://valoores.com/REG-AI',
    },
    {
        id: 2,
        image: slideTwo,
        subtitle: "They didn't know we were seeds",
        title: 'They tried to bury us,',
        description:
            'Celebrates our unshakable hope and faith, transforming every defeat into fertile ground for growth, uniting us in shared resilience, inspiring courage in others, and testifying that through divine strength, our trials become the very source of our victory.',
        // buttonText: 'Learn More',
        // buttonLink: `https://valoores.com?slide=2`,
    },
    {
        id: 3,
        image: slideThree,
        subtitle: 'The Architecture of Harmony',
        title: 'The Machine Plays. Humanity Sings.',
        description:
            'Machines provide speed, computation, and scale. Human intelligence provides wisdom, restraint, empathy, and direction.',
        // buttons: [
        //     {
        //         text: 'Strategy',
        //         link: strategyPdf,
        //     },
        //     {
        //         text: 'The Shift with NHI',
        //         link: shiftNhiPdf,
        //     },
        //     {
        //         text: 'Extended Symphonia and the Shift with NHI',
        //         link: symphoniaPdf,
        //     },
        // ],
        buttonText: 'Learn More',
        buttonLink: '/natural-human-intelligence',

    },
];

export default function HeroCarousel() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    const nextSlide = useCallback(() => {
        setActiveIndex((currentIndex) =>
            currentIndex === slides.length - 1 ? 0 : currentIndex + 1,
        );
    }, []);

    const previousSlide = () => {
        setActiveIndex((currentIndex) =>
            currentIndex === 0 ? slides.length - 1 : currentIndex - 1,
        );
    };

    useEffect(() => {
        if (isPaused) return undefined;

        const interval = window.setInterval(nextSlide, 6500);

        return () => {
            window.clearInterval(interval);
        };
    }, [isPaused, nextSlide]);

    return (
        <section
            className="hero-carousel"
            aria-label="Introduction carousel"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
        >
            <AnimatePresence mode="wait">
                <motion.article
                    key={slides[activeIndex].id}
                    className="hero-carousel__slide"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{
                        opacity: { duration: 0.8 },
                    }}
                >
                    <motion.div
                        className="hero-carousel__background"
                        style={{
                            backgroundImage: `url(${slides[activeIndex].image})`,
                        }}
                        initial={{ scale: 1 }}
                        animate={{ scale: 1.08 }}
                        transition={{
                            duration: 6.5,
                            ease: 'linear',
                        }}
                    />
                    {slides[activeIndex].id === 3 && (
                        <div className="hero-carousel__overlay" />
                    )}

                    <div className="hero-carousel__container">
                        <motion.div
                            className="hero-carousel__content"
                            // initial={{ opacity: 0, x: 80 }}
                            // animate={{ opacity: 1, x: 0 }}
                            transition={{
                                duration: 0.8,
                                delay: 0.25,
                                ease: [0.22, 1, 0.36, 1],
                            }}
                        >

                            <motion.h1
                                className="hero-carousel__title"
                                // initial={{ opacity: 0, y: 25 }}
                                // animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.7, delay: 0.45 }}
                            >
                                {slides[activeIndex].title}
                            </motion.h1>

                            <motion.span
                                className="hero-carousel__subtitle"
                                // initial={{ opacity: 0, y: 18 }}
                                // animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 0.35 }}
                            >
                                {slides[activeIndex].subtitle}
                            </motion.span>

                            <motion.p
                                className="hero-carousel__description"
                                // initial={{ opacity: 0, y: 25 }}
                                // animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.7, delay: 0.55 }}
                            >
                                {slides[activeIndex].description}
                            </motion.p>

                            {/* <motion.a
                                href={slides[activeIndex].buttonLink}
                                className="hero-carousel__button"
                                initial={{ opacity: 0, y: 25 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.7, delay: 0.65 }}
                            >
                                {slides[activeIndex].buttonText}

                                <span aria-hidden="true"><MoveRight size={15}/></span>
                            </motion.a> */}
                            {slides[activeIndex].buttons ? (
                                <motion.div
                                    className="hero-carousel__buttons"
                                    // initial={{ opacity: 0, y: 25 }}
                                    // animate={{ opacity: 1, y: 0 }}
                                    // transition={{ duration: 0.7, delay: 0.65 }}
                                >
                                    {slides[activeIndex].buttons.map((pdfButton) => (
                                        <a
                                            key={pdfButton.text}
                                            href={pdfButton.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="hero-carousel__button"
                                        >
                                            {pdfButton.text}

                                            <span aria-hidden="true">
                                                <MoveRight size={15} />
                                            </span>
                                        </a>
                                    ))}
                                </motion.div>
                            ) : (
                                slides[activeIndex]?.buttonText && (
                                    <motion.a
                                        href={slides[activeIndex].buttonLink}
                                        className="hero-carousel__button"
                                        // initial={{ opacity: 0, y: 25 }}
                                        // animate={{ opacity: 1, y: 0 }}
                                        // transition={{ duration: 0.7, delay: 0.65 }}
                                    >
                                        {slides[activeIndex].buttonText}

                                        <span aria-hidden="true">
                                            <MoveRight size={15} />
                                        </span>
                                    </motion.a>)
                            )}
                        </motion.div>
                    </div>
                </motion.article>
            </AnimatePresence>

            {/* Left arrow */}
            <button
                type="button"
                className="hero-carousel__arrow hero-carousel__arrow--left"
                onClick={previousSlide}
                aria-label="Previous slide"
            >
                <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    aria-hidden="true"
                >
                    <path
                        d="M15 5L8 12L15 19"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>

            {/* Right arrow */}
            <button
                type="button"
                className="hero-carousel__arrow hero-carousel__arrow--right"
                onClick={nextSlide}
                aria-label="Next slide"
            >
                <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    aria-hidden="true"
                >
                    <path
                        d="M9 5L16 12L9 19"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>

            {/* Bottom indicators */}
            <div className="hero-carousel__bottom">
                <div className="hero-carousel__dots">
                    {slides.map((slide, index) => (
                        <button
                            key={slide.id}
                            type="button"
                            className={`hero-carousel__dot ${activeIndex === index ? 'hero-carousel__dot--active' : ''
                                }`}
                            aria-label={`Open slide ${index + 1}`}
                            aria-current={activeIndex === index ? 'true' : undefined}
                            onClick={() => setActiveIndex(index)}
                        >
                            <span />
                        </button>
                    ))}
                </div>

                <span className="hero-carousel__counter">
                    {String(activeIndex + 1).padStart(2, '0')}
                    <span>/</span>
                    {String(slides.length).padStart(2, '0')}
                </span>
            </div>

            <div className="hero-carousel__scroll">
                <span />
                Scroll to explore
            </div>
        </section>
    );
}